import { render, staticRenderFns } from "./EmailCampaignRowDetail.vue?vue&type=template&id=18dc0022&scoped=true"
var script = {}
import style0 from "./EmailCampaignRowDetail.vue?vue&type=style&index=0&id=18dc0022&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dc0022",
  null
  
)

export default component.exports